import styled from 'styled-components';

// Components
import * as M from '../Message/Styled';

export const Label = styled.div`
  width: 68px;
  height: 68px;
  background: var(--white);
  border: 1px solid var(--aluminium60);
  border-radius: 50%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 6px;
  margin-bottom: 8px;

  @media (max-width: 767px) {
    width: 28px;
    height: 28px;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Icon = styled.div`
  width: 34px;
  height: 34px;
  background: url('/assets/images/drugs.png');
  margin-top: -2px;
  display: flex;
  align-items: center;

  @media (max-width: 767px) {
    width: 18px;
    height: 18px;
    background-size: cover;
  }
`;

export const Text = styled.div`
  font-size: 10px;
  line-height: 1.1em;
  font-weight: 600;
  color: var(--carbone120);
  padding: 0 5px;
  text-align: center;
  display: flex;
  align-items: center;
  top: -1px;
  position: relative;

  @media (max-width: 767px) {
    display: none;
  }
`;

export const ExtLabel = styled(Label)`
  &:hover {
    ${M.Message} {
      display: block;
    }
  }
`;
